module.exports = __webpack_public_path__ + "static/img/bgImage5.d587935.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/industryApplication/tab1/wap/bgImage5.jpg
// module id = 0cQc
// module chunks = 0